import { MicrositeTemplate } from '~/model';
import { useRegisterSection } from '~/hooks/useSections';
import ListingBlockAlpha from '~/editor/templates/alpha/ListingBlockAlpha';
import ListingBlockDelta from '~/editor/templates/delta/ListingBlockDelta';
import ListingBlockEpsilon from '~/editor/templates/epsilon/ListingBlockEpsilon';
import ListingBlockEta from '~/editor/templates/eta/ListingBlockEta';
import ListingBlockZeta from '~/editor/templates/zeta/ListingBlockZeta';
import { type ComponentConfig } from '@puckeditor/core';
import ListingBlockBeta from '~/editor/templates/beta/ListingBlockBeta';

export interface ListingBlockProps {
	navigation?: boolean;
	template: MicrositeTemplate;
}

export const PUCK_BLOCK_LISTING: ComponentConfig<ListingBlockProps> = {
	label: 'Listing Details',
	fields: {
		navigation: {
			type: 'radio',
			options: [
				{ label: 'On', value: true },
				{ label: 'Off', value: false },
			],
		},
		template: {
			type: 'radio',
			options: [
				{ label: 'Alpha', value: MicrositeTemplate.ALPHA },
				{ label: 'Beta', value: MicrositeTemplate.BETA },
				{ label: 'Delta', value: MicrositeTemplate.DELTA },
				{ label: 'Epsilon', value: MicrositeTemplate.EPSILON },
				{ label: 'Eta', value: MicrositeTemplate.ETA },
				{ label: 'Zeta', value: MicrositeTemplate.ZETA },
			],
		},
	},
	defaultProps: {
		navigation: true,
		template: MicrositeTemplate.ETA,
	},
	permissions: {
		duplicate: false,
	},
	render(props) {
		return <ListingBlock {...props} />;
	},
};

export default function ListingBlock({ navigation = true, template }: ListingBlockProps) {
	const id = useRegisterSection('listing', 'Listing', navigation);

	let content = <></>;

	if (template === MicrositeTemplate.ALPHA) {
		content = <ListingBlockAlpha id={id} />;
	}
	if (template === MicrositeTemplate.BETA) {
		content = <ListingBlockBeta />;
	}
	if (template === MicrositeTemplate.DELTA) {
		content = <ListingBlockDelta />;
	}
	if (template === MicrositeTemplate.EPSILON) {
		content = <ListingBlockEpsilon />;
	}
	if (template === MicrositeTemplate.ETA) {
		content = <ListingBlockEta />;
	}
	if (template === MicrositeTemplate.ZETA) {
		content = <ListingBlockZeta />;
	}

	return content;
}
